import { I18N } from "./I18N.js"

export class StoreOfflineDialog {
	_store
	_target

	constructor(target, store) {
		this._store = store
		this._target = document.getElementById(target)
		this._target.setAttribute('hidden', '')
	}

	close = () => this.setVisible(false)

	setVisible = visible => {
		if (visible) {
			const phone = this._store.contact?.phone || ''
			this._target.innerHTML = `
				<div class="modalCanvas">
				<div id="storeOfflineModalShader" class="modalShader"></div>
				<div class="card modal">
					<button id="storeOfflineCloseBtn" class="closeBtn"><span class="material-icons">close</span></button>
					<div class="dlgTopSpacer"><h2 i18n>Store offline</h2></div>
					<div class="card">
						<p>${I18N.translateAndFormat('The store is currently offline. Try ordering by phone at {0}.', phone)}</p>
					</div>
				</div>
			`
			I18N.translateElement(this._target)
			this._target.removeAttribute('hidden')
			document.getElementById('storeOfflineCloseBtn').addEventListener('click', () => this.setVisible(false))
			document.getElementById('storeOfflineModalShader').addEventListener('click', () => this.setVisible(false))
		}
		else {
			this._target.innerHTML = ''
			this._target.setAttribute('hidden', '')
		}
	}
}
